import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";

// Async action to fetch booking history
export const fetchBookingHistory = createAsyncThunk(
  "booking/fetchBookingHistory",
  async ({ fromDate, toDate, bookingRefNo,UserId } = {}, { rejectWithValue }) => {
    console.log("Fetching booking history with params:", { fromDate, toDate, bookingRefNo,UserId });
    try {
      let url = `${REACT_APP_API_URL}api/dashboard/admin/booking-history`;

      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);
      if (bookingRefNo) params.append("bookingRefNo", bookingRefNo);
      if (UserId && Number(UserId) > 0) params.append("UserId", UserId);


      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      console.log("Request URL:", url);


      const response = await axios.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch booking history");
    }
  }
);

export const bookingView = createAsyncThunk(
  "booking/bookingView",
  async (P_intBookingID) => {
    try {
      const response = await axios.get(`${REACT_APP_API_URL}/api/dashboard/admin/booking-view/${P_intBookingID}`);
      console.log("📌 API Response in bookingView:", response.data);
      return response.data.data; // Return the response data
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const bookingPaid = createAsyncThunk(
  "booking/bookingPaid",
  async ({P_intBookingID,bookingPayment}) => {
    try {
      console.log("BookingId", P_intBookingID)
      console.log("Booking Paid", bookingPayment)
    
      const response = await axios.get(`${REACT_APP_API_URL}/api/dashboard/admin/booking-payment/${P_intBookingID}/${bookingPayment}`);
      
      return response.data.data; 
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const bookingExtraPerson = createAsyncThunk(
  "booking/bookingExtraPerson",
  async (P_intBookingID) => {
    try {
      
      const response = await axios.get(`${REACT_APP_API_URL}/api/dashboard/admin/booking-extraperson/${P_intBookingID}`);
      
      return response.data.data; 
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    data: [],
    selectedBooking: [],
    selectedPayment:[],
    extraPerson:[],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingHistory.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBookingHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
        state.error = null;  // Clear any previous error on success
      })
      .addCase(fetchBookingHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;  // More detailed error handling
      })
      .addCase(bookingView.pending, (state) => {
        state.status = "loading";
      })
      .addCase(bookingView.fulfilled, (state, action) => {
        
        state.status = "succeeded";
        state.selectedBooking = action.payload; // Storing only the data array
        state.error = null;
      })
      .addCase(bookingView.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(bookingPaid.pending, (state) => {
        state.status = "loading";
      })
      .addCase(bookingPaid.fulfilled, (state, action) => {        
        state.status = "succeeded";
        state.selectedPayment = action.payload; 
        state.error = null;
      })
      .addCase(bookingPaid.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(bookingExtraPerson.pending, (state) => {
        state.status = "loading";
      })
      .addCase(bookingExtraPerson.fulfilled, (state, action) => {        
        state.status = "succeeded";
        state.extraPerson = action.payload; 
        state.error = null;
      })
      .addCase(bookingExtraPerson.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

// Export reducer
export default bookingSlice.reducer;